import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from 'reducers';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createStore, applyMiddleware } from 'redux';
import { REDUCER_KEY as TICMART_REDUCER_KEY } from 'modules/ticmart/redux/reducers';
import asyncActionCreator from './middlewares/asyncActionCreator';

const persistedReducer = persistReducer(
  { key: 'root', storage, blacklist: ['buyerInspection', TICMART_REDUCER_KEY] },
  rootReducer
);
const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(applyMiddleware(asyncActionCreator, thunk))
);

const persistor = persistStore(store, [null, () => {}]);
export { store, persistor };
export default store;
